import type { LinkedImage, LinkedImageList } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSLinkedImage } from '@swf/cms';

import styles from './CMSLinkedImageList.scss';

interface Props extends LinkedImageList {
  isFooter?: boolean;
}
const getClassNameByType = (type: string, isFooter?: boolean) => {
  switch (type) {
    case 'Social Media':
      return isFooter ? 'footerSocialMedia' : 'socialMedia';
    default:
      return 'image';
  }
};
const CMSLinkedImageList: React.FC<Props> = ({ items, isFooter, type }) => {
  const className = getClassNameByType(type || '', isFooter);

  return (
    <div className={styles[`${className}Container`]}>
      {items.map((image, index) => {
        const linkedImage = { ...(image as { linked_image: LinkedImage }).linked_image };
        linkedImage.link.target = '_blank';
        return (
          <CMSLinkedImage key={index} className={styles[`${className}Image`]} {...linkedImage} />
        );
      })}
    </div>
  );
};
export default CMSLinkedImageList;
